const EXPERTS = ["elina", "anna", "simona", "no_coach"]
import { TrackingManager } from "../../../../lib/common/js/services/tracking/trackingManager"

// Brand-specific Premium upsell component extended from
// common upsell component with global functionality
export default (commonUpsell) =>
  ({
    offerPath,
    paymentsPath,
    paymentsFailPath,
    paymentsSuccessPath,
    chancePath,
    sendOffPath,
  } = {}) => ({
    // Init common upsell functionality
    internalTracker: new TrackingManager(
      window.trackingConfig.enabledTrackingServices,
      pipelineConfig,
    ),

    ...commonUpsell({
      upsellOfferType: "chat",
      offerPath,
      paymentsPath,
      paymentsFailPath,
      paymentsSuccessPath,
      chancePath,
      sendOffPath,
    }),

    // Add or overwrite brand-specific functionality
    experts: EXPERTS,
    selectedExpert: EXPERTS[0],

    selectExpert(id) {
      this.selectedExpert = this.experts[id - 1]
      this.internalTracker.trackClick({
        clickName: `Expert Selected`,
      })

      this.store.values.selectedChatNutrionist = this.selectExpert
    },

    isExpertSelected(id) {
      return this.selectedExpert === this.experts[id - 1]
    },

    isExpertRecommended(id) {
      return id === 1
    },

    handleRejectOffer(skipCurrentUpsellOffer) {
      this.internalTracker.trackClick({
        clickName: this.upsellEventName["chat"]["reject"],
      })
      if (skipCurrentUpsellOffer) {
        this.skipCurrentUpsellOffer()
      } else {
        this.goToChance()
      }
    },

    isNoExpert(id) {
      return this.experts[id - 1] === "no_coach"
    },

    async handlePurchase(isModal) {
      if (isModal) {
        this.store.values.selectedChatNutrionist = this.selectExpert
        this.purchase()

        return
      }

      // If no expert chosen - open chance modal screen
      if (this.selectedExpert === "no_coach") {
        this.internalTracker.trackClick({
          clickName: this.upsellEventName["chat"]["reject"],
        })

        this.goToChance()

        return
      }

      this.internalTracker.trackClick({
        clickName: this.upsellEventName["chat"]["accept"],
      })

      this.purchase()
    },
  })
